import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-bar-code-icon',
    templateUrl: './bar-code-icon.component.html',
    standalone: false
})
export class BarCodeIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
